import type { RecordRepositoryPort } from "@/application/records/ports/RecordRepositoryPort";
import type {
  RecordPresenterPort,
  RecordViewModel,
} from "@/application/records/ports/RecordPresenterPort";
import type { RecordId } from "@/domain/records/types";

/**
 * Use Case for loading record with metadata
 * Clean Architecture - Application Layer
 */
export class LoadRecordUseCase {
  constructor(
    private readonly recordRepository: RecordRepositoryPort,
    private readonly recordPresenter: RecordPresenterPort
  ) {}

  /**
   * Execute the use case to load a record
   */
  async execute(recordId: RecordId): Promise<{
    record: RecordViewModel | null;
    isLoading: boolean;
    error?: string;
  }> {
    try {
      const record = await this.recordRepository.getById(recordId);
      const viewModel = this.recordPresenter.present(record);

      return {
        record: viewModel,
        isLoading: false,
      };
    } catch (error) {
      console.error("Failed to load record:", error);
      return {
        record: null,
        isLoading: false,
        error: error instanceof Error ? error.message : "Failed to load record",
      };
    }
  }

  /**
   * Check if record can be loaded
   */
  canExecute(recordId: RecordId): boolean {
    return Boolean(recordId && recordId.trim().length > 0);
  }
}
